import { t } from '@/plugins/i18n'
export const productColumns:any = [
  {
    label: t('图片'),
    prop: 'productMainImg',
    align: 'center',
    slotName: 'productMainImg'
  },
  {
    label: t('平台商品信息'),
    prop: 'productSkuInfo',
    width: 250,
    align: 'center',
    slotName: 'productSkuInfo'
  },
  {
    label: t('平台商品SKU'),
    prop: 'productSku',
    width: 250,
    align: 'center'
  },
  {
    label: t('客户商品sku'),
    prop: 'customerProductMsku',
    align: 'center',
    sortable: 'customerProductMsku'
  },
  {
    label: '',
    prop: 'skuFile',
    align: 'center',
    width: 220,
    slotName: 'skuFile',
    slotHeadName: 'skuFileHead'
  },
  {
    // label: t('库存数量'),
    prop: 'useable',
    align: 'center',
    slotName: 'useable',
    slotHeadName: 'useableHead'
  },
  {
    label: t('发货数量'),
    prop: 'deliveryNums',
    align: 'center',
    slotName: 'deliveryNums',
    width: 150
  }
]

export const productApiConfig:any = {
  listPath: 'data'
}

export const productTableConfig = {
  showSelection: true
}

export const productTableConfig2 = {
  showSelection: true,
  showHandler: true,
  rowKey: 'productSku'
}

export const thirdWarehouseTypeDict: any = {
  0: t('其他'),
  1: t('FBA发货'),
  2: t('乐天'),
  3: t('SHOPLIST'),
  4: t('ZOZOTOWN')
}

export const dynamicAggregate: any = {
  2: {
    label: t('乐天SKU'),
    prop: 'amazonProductTitle',
    align: 'center',
    width: 200
  }
}

export const skuTemplate: any = {
  0: require('@/assets/image/SKUtemplate/other.png'),
  1: require('@/assets/image/SKUtemplate/other.png'),
  2: require('@/assets/image/SKUtemplate/letian.png'),
  3: require('@/assets/image/SKUtemplate/shoplist.png'),
  4: require('@/assets/image/SKUtemplate/zozotown.png')
}
